<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Datos Generales de la Baja
              |  
              a.button.is-default.is-rounded.is-medium(@click="backPage")
                i.fas.fa-times
            br
        .columns
          .column.is-12
            div.box
              .columns
                .column.is-6
                  span  Descripción: {{ articuloBD.categoria}} {{articuloBD.subcategoria ? ` ${articuloBD.subcategoria}` : '' }}
                .column.is-3
                  span(v-show="articuloBD.marca")  Marca: {{ articuloBD.marca}} 
                .column.is-3
                  span(v-show="articuloBD.modelo")  Modelo: {{ articuloBD.modelo }}
              .columns
                .column.is-6
                  span  Resguardo: {{ articuloBD.resguardo}}
                .column.is-6
                  span  Ubicación: {{ articuloBD.ubicacion}}
        .columns.is-vcentered
          .column.is-3
            .field
              label.label Fecha Baja
              .control
                flat-pickr(
                  v-model='fecha'
                  :config="config"
                  class="input is-primary"
                )
          .column.is-3
            .field
              label.label Entrega
              .control
                Typeahead(:options="usuarios" :optionSelect="usuarioSelect" :tema="typeTipos" v-model="usuarioSelect")
          .column.is-2
            .field
              input#iActivos.is-checkradio.is-dark(type='checkbox' v-model='isActivo')
              label.is-size-6(for='iActivos') Activos
          .column.is-4
            .field
              label.label Justificación
                .control.has-icons-left.has-icons-right
                  textarea.textarea.is-dark(
                    type='text', 
                    placeholder='Justificación de la baja',
                    v-model="justificacion"
                    rows="2"
                  )
        .columns(v-show="datosFaltantes.length > 0")
          .column.is-12
            .notification
              .field.is-grouped.is-grouped-multiline
                .control(v-for="datosF in datosFaltantes")
                  .tags
                    span.tag.is-danger.is-light {{ datosF }}
        .columns.has-text-centered
          .column.is-4.is-offset-4
            a.button.is-primary.is-rounded.is-medium.is-block(@click="checkForm") Guardar
</template>

<script>
  import Loader from '../shared/Loader.vue'
  import NavBarInventario from './layout/NavBarInventario.vue'
  import Typeahead from './Typeahead.vue'
  import InventarioServices from '../../services/inventario/inventario'
  import usuariosServices from '../../services/usuarios/usuarios'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import 'flatpickr/dist/plugins/monthSelect/style.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import moment from 'moment'
  import { mapState } from 'vuex'
  import { evall } from '../../configSystem'
  const Cryptr = require('cryptr')
  export default {
    name: 'BajaArticulo',
    components: { Loader, NavBarInventario, Typeahead, flatPickr },
    data () {
      return {
        isLoading: true,
        origen: '',
        fecha: moment().format('YYYY-MM-DD'),
        config: {
          wrap: false, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m-d',
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: Spanish, // locale for this instance only
        },
        isEditing: false,
        usuarios: [],
        datosFaltantes: [],
        almacenes: [],
        myObjBaja: {},
        claveBaja: '',
        idBD: '',
        usuarioSelect: {},
        typeTipos: '',
        articuloBD: {},
        justificacion: '',
        fechaReg: '',
        userAutoriza: {},
        isActivo: false,
      }
    },
    methods: {
      iniciarComponente() {
        this.obtenerDataArticulo()
      },
      
      obtenerDataArticulo() {
        InventarioServices.getArticulosInd(this.articuloBaja)
          .then( data => {
            this.articuloBD = this.convetirArticulo(data[0])
            this.obtenerUsuarios()
          })
          .catch( e=> {
            this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
          })
      },
      
      convetirArticulo(a) {
        return {
          ...a,
          estado: parseInt(a.estado),
          garantia: parseInt(a.garantia),
          id_artBase: parseInt(a.id_artBase),
        }
      },

      obtenerUsuarios() {
        usuariosServices.getUsuarios()
          .then(res => {
            this.usuarios = res.map(this.convertirUsuarios)
            this.userAutoriza = this.usuarios.find( u => u.puesto === '001')
            this.obtenerAlmacenes()
          })
          .catch( e=> {
            this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
          })
      },

      convertirUsuarios(user) {
        return {
          ...user,
          departamento: parseInt(user.departamento),
          categoria: parseInt(user.categoria),
          jefeArea: parseInt(user.jefeArea),
          text: user.nombre,
        }
      },
      obtenerAlmacenes() {
        InventarioServices.getAlmacenesConsumibles('c')
          .then( data => {
            this.almacenes = data.map(this.convertirAlmacenes)
            this.obtenerAlmacenOrigen()
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
          })
      },

      convertirAlmacenes (ofi) {
        return {
          ...ofi,
          id: parseInt(ofi.id),
          id_ubicacion: parseInt(ofi.id_ubicacion),
          id_oficina: parseInt(ofi.id_oficina),
          inventario: parseInt(ofi.inventario) == 1 ? true : false,
        }
      },

      obtenerAlmacenOrigen() {
        this.usuarioSelect = this.usuarios.find( u => u.id === this.articuloBD.idResguardo)
        this.almacenes.map( alm => {
          const encontrado = alm.almacenistas.find( a => a.id_usuario === this.userLogin.id)
          if (encontrado) {
            this.origen = alm
          }
        })
        this.isLoading = false
      },

      checkForm () {
        this.datosFaltantes = []
        if (this.justificacion !== '' && Object.keys(this.usuarioSelect).length > 0) {
          this.saveBaja()
        } else {
          if (this.justificacion === '') {
            this.datosFaltantes.push('La Justificación es requerida.')
          }
          if (Object.keys(this.usuarioSelect).length == 0) {
            this.datosFaltantes.push('El usuario que entrega es requerido.')
          }
        }
      },

      saveBaja() {
        this.isLoading = true
        let ahora = moment()
        let fechaI = ahora.startOf('month').format('YYYY-MM-DD')
        let fechaF = ahora.endOf('month').format('YYYY-MM-DD')

        InventarioServices.countBajas(fechaI, fechaF) 
          .then(res => {
            let hoy = moment()
            let month = hoy.format('MM')
            let year = hoy.format('YY')
            this.fechaReg = hoy.format('YYYY-MM-DD HH:mm:ss')

            switch (true) {
              case parseInt(res[0].total) < 10:
                this.claveBaja = `DUCTER-BAJA-${year}${month}_00${res[0].total}`
                break
              case parseInt(res[0].total) < 100:
                this.claveBaja = `DUCTER-BAJA-${year}${month}_0${res[0].total}`
                break
              case parseInt(res[0].total) < 1000:
                this.claveBaja = `DUCTER-BAJA-${year}${month}_${res[0].total}`
                break
              default:
                this.claveBaja = `DUCTER-BAJA-${year}${month}_00${res[0].total}`
                break
            }
            
            let hash = ''
            const dep = this.userLogin.categoria == 0 ? 2 : this.userLogin.departamento
            InventarioServices.saveBaja(this.claveBaja, this.fecha, this.fechaReg, this.articuloBD.id, 
            this.usuarioSelect.id, this.usuarioSelect.nombre, this.userAutoriza.id, this.userAutoriza.nombre, 
            this.articuloBD.ubicacion, this.articuloBD.oficina, this.origen.ubicacion, this.origen.clave, 
            hash, this.justificacion, dep, this.isActivo ? 1 : 0)
            .then( res => {
              if (res.success) {
                this.myObjBaja = {
                  id_baja: parseInt(res.getData),
                  clave_baja: this.claveBaja,
                  fecha: this.fecha,
                  fechaReg: this.fechaReg,
                  id_articulo: this.articuloBD.id,
                  id_entrega: this.usuarioSelect.id,
                  entrega: this.usuarioSelect.nombre,
                  id_autoriza: this.userAutoriza.id,
                  autoriza: this.userAutoriza.resguardo,
                  origen: this.articuloBD.ubicacion,
                  ofi_origen: this.articuloBD.oficina,
                  destino: this.origen.ubicacion,
                  ofi_destino: this.origen.clave,
                  hash: hash,
                  justificacion: this.justificacion,
                  observacion: '',
                  estado: 1,
                  firma: 'E',
                }

                let ahora1 = Date.now()
                let idUbi = `${ahora1.toString()}b`
                
                InventarioServices.addUbicacion(idUbi,this.articuloBD.id, this.fechaReg,this.origen.ubicacion,
                this.origen.clave,this.userLogin.id, this.userLogin.nombre,this.usuarioSelect.id, 
                this.usuarioSelect.text, '12')
                  .then(resUbi => {
                    if (resUbi.success) {
                      this.displayToast('toasted-primary', 'La Baja se ha registrado correctamente.','done', 'ok')
                      this.firmarBaja(this.myObjBaja)
                    } else {
                      this.displayToast('bubble',`Error: ${resUbi.respuesta}`, 'ban', 'OK')
                    }
                  })
                  .catch((e) => {
                    this.isLoading = false
                    this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
                  })
              } else {
                this.isLoading = false
                this.displayToast('bubble',`Error: ${res.respuesta}`, 'ban', 'OK')
              }
            })
            .catch((e) => {
              this.isLoading = false
              this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
            })

          })
        
        
      },

      firmarBaja(baja) {
          this.$store.commit('firmarBaja', baja)
          this.$router.push('/Inventario/Almacen/Bajas/Firma')
      },

      backPage() {
        this.$router.back()
      },
      
      displayToast(tema,text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },

      encriptarId()  {
        this.isLoading = true
        try {
          const cryptr = new Cryptr(evall)
          const encryptedString = cryptr.encrypt(this.claveBaja)
          return encryptedString
        } catch (error) {
          console.log(error)
          return error
        }
      },
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['userLogin', 'articuloBaja'])
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/BajaArticulo.vue